import React, { useCallback } from 'react';
import { findUnlimitedAgentsAPI } from '../../services/unlimitedAgentsService';

type Hook = {
  findUnlimitedAgents: (id: string) => Promise<any>;
};

const useUnlimitedAgents = (): Hook => {
  const findUnlimitedAgents = useCallback(async (id: string) => {
    try {
      return await findUnlimitedAgentsAPI(id);
    } catch (error) {
      console.error('Failed to fetch unlimited agent:', error);
      throw error;
    }
  }, []);

  return { findUnlimitedAgents };
};

export default useUnlimitedAgents;
